import useAppSelector from "@/core/helpers/useAppSelector";
import { ActionButton } from "@/shared/ui";
import { IS_DEV } from "@/domains/main/constants/other";
import { activeKeySelector } from "@/domains/activeKey/slice";
import useEscapeKeyPress from "@/domains/loadingScreen/hooks/useEscapeKeyPress";
import useShowLoadingScreen from "@/domains/loadingScreen/hooks/useShowLoadingScreen";
import LoadingScreenLoader from "@/domains/loadingScreen/components/LoadingScreenLoader";
import LoadingScreenLogo from "@/domains/loadingScreen/components/LoadingScreenLogo";
import LoadingScreenWrapper from "@/domains/loadingScreen/components/LoadingScreenWrapper";
import KeyCode from "@/assets/constants/key-code";

export default function LoadingScreenContainer() {
  const { isShow } = useShowLoadingScreen();
  const activeKey = useAppSelector(activeKeySelector);

  useEscapeKeyPress();

  if (!IS_DEV && !isShow) return null;

  return (
    <LoadingScreenWrapper>
      <LoadingScreenLogo />
      <LoadingScreenLoader />
      <ActionButton
        action="ESC"
        label="выйти из игры"
        isActive={activeKey === KeyCode.ESCAPE}
        key={KeyCode.ESCAPE}
        className="mt-auto mb-[3.75rem]"
      />
    </LoadingScreenWrapper>
  );
}
